import React,{Fragment} from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from '../../../assets/images/ugcan_logo_V3.svg';
import {
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  Accordion,
  AccordionHeader,
  AccordionBody,
  //Alert,
  Drawer,
  Card,
} from "@material-tailwind/react";
import {
  PresentationChartBarIcon,
  //SparklesIcon,
  //UserCircleIcon,
  InboxIcon,
  //PowerIcon,
  //HomeIcon,
  //InformationCircleIcon,
  //CogIcon,
  //ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/solid";
import {
  ChevronRightIcon,
  ChevronDownIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
//import { useUser } from "../../store/UserContext";
//import { clearTokens } from '../../Authentication/auth';

export function RightBurgerMenu() {
  //const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [openCET, setOpenCET] = React.useState(0);
  const [openCAP, setOpenCAP] = React.useState(0);
  //const [openAlert, setOpenAlert] = React.useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
    
  const CEThandleOpen = (value) => {
    setOpenCET(openCET === value ? 0 : value);
  };

  const CAPhandleOpen = (value) => {
    setOpenCAP(openCAP === value ? 0 : value);
  };

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  
  const handleNavigation = (path) => {
    navigate(path);
    closeDrawer();
  };

  // Effect to ensure drawer appears above all content
  React.useEffect(() => {
    if (isDrawerOpen) {
      document.body.classList.add('drawer-open');
      
      // Lower z-index of main content
      const lowerContentZIndex = () => {
        const drawerContent = document.querySelector('.drawer-content');
        if (drawerContent) {
          const computedStyle = window.getComputedStyle(drawerContent);
          if (computedStyle.position === 'static') {
            drawerContent.style.position = 'relative';
          }
          drawerContent.style.zIndex = '0';
        }
      };
      
      // Set high z-index on drawer elements
      const setDrawerZIndex = () => {
        // Find drawer elements by class, role, or data attributes
        const drawerElements = document.querySelectorAll(
          '[class*="drawer"]:not(.drawer-content), [class*="Drawer"]:not(.drawer-content), [role="presentation"]'
        );
        
        drawerElements.forEach((el) => {
          const computedStyle = window.getComputedStyle(el);
          if (computedStyle.position === 'static') {
            (el).style.position = 'fixed';
          }
          (el).style.zIndex = '999999';
        });
        
        // Find large fixed elements that might be the drawer
        const fixedElements = document.querySelectorAll('[style*="position: fixed"], [style*="position:fixed"]');
        fixedElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.width > 200 && rect.height > 400) {
            (el).style.zIndex = '999999';
          }
        });
      };
      
      // Initial setup with small delay to ensure drawer is rendered
      setTimeout(() => {
        setDrawerZIndex();
        lowerContentZIndex();
      }, 50);
      
      // Keep z-index correct while drawer is open
      const interval = setInterval(() => {
        setDrawerZIndex();
        lowerContentZIndex();
      }, 100);
      
      return () => {
        clearInterval(interval);
        document.body.classList.remove('drawer-open');
        // Reset content z-index when drawer closes
        const drawerContent = document.querySelector('.drawer-content');
        if (drawerContent) {
          drawerContent.style.zIndex = '';
          drawerContent.style.position = '';
        }
      };
    } else {
      document.body.classList.remove('drawer-open');
    }
  }, [isDrawerOpen]);
    
  return (
    <Fragment>
      <IconButton 
        variant="text" 
        size="lg" 
        onClick={openDrawer}
        className="hover:bg-primary-100 hover:text-primary-900 transition-all duration-200 rounded-lg"
      >
        {isDrawerOpen ? (
          <XMarkIcon className="h-8 w-8 stroke-2" />
        ) : (
          <Bars3Icon className="h-8 w-8 stroke-2" />
        )}
      </IconButton>
      <Drawer 
        className="bg-white shadow-2xl" 
        open={isDrawerOpen} 
        onClose={closeDrawer}
        placement="left"
        size={400}
      >
        <Card
          color="transparent"
          shadow={false}
          className="h-[calc(100vh-2rem)] w-full p-0 flex flex-col"
        >
          {/* Header Section with Logo and Close Button */}
          <div className="flex items-center justify-between px-6 py-5 border-b-2 border-primary-200 bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 shadow-sm">
            <div className="flex items-center">
              <div className="w-32">
                <Logo className="w-full h-auto" />
              </div>
            </div>
            <IconButton 
              variant="text" 
              size="sm" 
              onClick={closeDrawer}
              className="rounded-full hover:bg-primary-200 hover:text-primary-900 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <XMarkIcon className="h-6 w-6" />
            </IconButton>
          </div>

          {/* Menu List */}
          <div className="flex-1 overflow-y-auto px-4 py-6 bg-white">
            <List className="text-secondary-900">
              <ListItem 
                className="rounded-xl mb-3 hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 hover:text-primary-900 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-3"
                ripple={true}
                onClick={() => handleNavigation("/overview")}
              >
                <ListItemPrefix>
                  <div className="p-2 rounded-lg bg-primary-100 mr-3">
                    <InboxIcon className="h-5 w-5 text-primary-700" />
                  </div>
                </ListItemPrefix>
                <span className="w-full font-semibold text-base">
                  About Us
                </span>
              </ListItem>
            <Accordion
              open={openCET === 1}
              icon={
                <ChevronDownIcon
                  strokeWidth={2.5}
                  className={`h-5 w-5 text-primary-700 transition-transform duration-300 ${
                    openCET === 1 ? "rotate-180" : ""
                  }`}
                />
              }
            >
              <ListItem className="p-0 mb-3 rounded-xl" selected={openCET === 1}>
                <AccordionHeader
                  onClick={() => CEThandleOpen(1)}
                  className={`border-b-0 p-4 rounded-xl transition-all duration-300 shadow-sm ${
                    openCET === 1 
                      ? "bg-gradient-to-r from-primary-100 to-emerald-100 text-primary-900 shadow-md border border-primary-200" 
                      : "hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 hover:shadow-md border border-transparent hover:border-primary-200"
                  }`}
                >
                  <ListItemPrefix>
                    <div className={`p-2 rounded-lg mr-3 transition-colors duration-300 ${
                      openCET === 1 ? "bg-primary-200" : "bg-primary-100"
                    }`}>
                      <PresentationChartBarIcon className="h-5 w-5 text-primary-700" />
                    </div>
                  </ListItemPrefix>
                  <Typography className="mr-auto font-bold text-base text-secondary-900">
                    CET Zone
                  </Typography>
                </AccordionHeader>
              </ListItem>
              <AccordionBody className="py-3 px-2">
                <List className="p-0 space-y-2">
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/cetzone/exam-dates")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      Exam Dates
                    </span>
                  </ListItem>
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/cetzone/exam-notices")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      Exam Notices
                    </span>
                  </ListItem>
                </List>
              </AccordionBody>
            </Accordion>
            <Accordion
              open={openCAP === 1}
              icon={
                <ChevronDownIcon
                  strokeWidth={2.5}
                  className={`h-5 w-5 text-primary-700 transition-transform duration-300 ${
                    openCAP === 1 ? "rotate-180" : ""
                  }`}
                />
              }
            >
              <ListItem className="p-0 mb-3 rounded-xl" selected={openCAP === 1}>
                <AccordionHeader
                  onClick={() => CAPhandleOpen(1)}
                  className={`border-b-0 p-4 rounded-xl transition-all duration-300 shadow-sm ${
                    openCAP === 1 
                      ? "bg-gradient-to-r from-primary-100 to-emerald-100 text-primary-900 shadow-md border border-primary-200" 
                      : "hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 hover:shadow-md border border-transparent hover:border-primary-200"
                  }`}
                >
                  <ListItemPrefix>
                    <div className={`p-2 rounded-lg mr-3 transition-colors duration-300 ${
                      openCAP === 1 ? "bg-primary-200" : "bg-primary-100"
                    }`}>
                      <PresentationChartBarIcon className="h-5 w-5 text-primary-700" />
                    </div>
                  </ListItemPrefix>
                  <Typography className="mr-auto font-bold text-base text-secondary-900">
                    CAP Zone
                  </Typography>
                </AccordionHeader>
              </ListItem>
              <AccordionBody className="py-3 px-2">
                <List className="p-0 space-y-2">
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/capzone/nirf-rankings")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      NIRF Ranking
                    </span>
                  </ListItem>
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/capzone/caps-dates")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      CAP Dates
                    </span>
                  </ListItem>
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/capzone/caps-notices")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      CAP Notices
                    </span>
                  </ListItem>
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/capzone/seat-matrix")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      Seats
                    </span>
                  </ListItem>
                  <ListItem 
                    className="rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-2.5 ml-4"
                    onClick={() => handleNavigation("/capzone/rank-cutoffs")}
                  >
                    <ListItemPrefix>
                      <div className="p-1.5 rounded-md bg-emerald-100 mr-3">
                        <ChevronRightIcon strokeWidth={2.5} className="h-4 w-4 text-emerald-700" />
                      </div>
                    </ListItemPrefix>
                    <span className="w-full text-sm font-semibold text-secondary-700 hover:text-primary-900 transition-colors">
                      Cutoffs
                    </span>
                  </ListItem>
                </List>
              </AccordionBody>
            </Accordion>
            
            {/* Divider */}
            <hr className="my-6 border-t-2 border-primary-200" />
            
            {/* Contact Us */}
            <ListItem 
              className="rounded-xl hover:bg-gradient-to-r hover:from-primary-50 hover:to-emerald-50 hover:text-primary-900 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md border border-transparent hover:border-primary-200 px-4 py-3"
              ripple={true}
              onClick={() => handleNavigation("/contactus")}
            >
              <ListItemPrefix>
                <div className="p-2 rounded-lg bg-primary-100 mr-3">
                  <InboxIcon className="h-5 w-5 text-primary-700" />
                </div>
              </ListItemPrefix>
              <span className="w-full font-semibold text-base">
                Contact Us
              </span>
            </ListItem>
            {/*
            <ListItem>
              <ListItemPrefix>
                <UserCircleIcon className="h-5 w-5" />
              </ListItemPrefix>
              Profile
            </ListItem>
            <ListItem>
              <ListItemPrefix>
                <PowerIcon className="h-5 w-5" />
              </ListItemPrefix>
              Log Out
            </ListItem>
            */}
          </List>
          </div>
          {/*
          <Alert
            open={openAlert}
            className="mt-auto"
            onClose={() => setOpenAlert(false)}
          >
            <SparklesIcon className="mb-4 h-12 w-12 text-yellow-600" />
            <Typography variant="h6" className="mb-1">
             Early bird offer for the first 1000 students: Get 1 year of Free Membership! 🎉
            </Typography>
            <Typography variant="small" className="font-normal opacity-80">
              Choose the plan that fits you best — monthly, half-yearly, or yearly. Get access to the student community, save your preferences, and stay updated on everything college-related. 
            </Typography>
            <Typography variant="small" className="font-bold opacity-80">
              Plans start at just ₹99.
            </Typography>
            <div className="mt-4 flex gap-3">
              <Typography
                as="a"
                href="#"
                variant="small"
                className="font-medium opacity-80"
                onClick={() => setOpenAlert(false)}
              >
                Dismiss
              </Typography>
              <Typography
                as="a"
                href="#"
                variant="small"
                className="font-medium"
              >
                Upgrade Now
              </Typography>
            </div>
          </Alert>
          */}
        </Card>
      </Drawer>
    </Fragment>
  );
}
